import {useParams} from "react-router";
import {css} from "@emotion/react";

import {calculateRemSize as crs, listUnStyled, onDesktop} from "@pg-design/helpers-css";
import {sortBy} from "@pg-mono/nodash";
import {useUserDevice} from "@pg-mono/user-device";

import {useGetOfferDetailListQuery} from "../../../../offer/api/get_offer_detail_list";
import {useGetRegionDetailListBySlugQuery} from "../../../../region/api/get_region_detail_list_by_slug";
import {rankingBigViewBreakpoint} from "../../../constants/ranking_big_view_breakpoint";
import {IRankingItem} from "../../../types/IRankingItem";
import {IRankingListingViewParams} from "../../../types/IRankingListingViewParams";
import {getRankingItems} from "../../../utils/get_ranking_items";
import {OfferRankingCard} from "./OfferRankingCard";
import {OfferRankingListItem} from "./OfferRankingListItem";

export function OfferRankingList() {
    const userDevice = useUserDevice();
    const {citySlug} = useParams<IRankingListingViewParams>();
    const {data} = useGetRegionDetailListBySlugQuery({slug: citySlug});
    const currentRegion = data?.results[0];
    const rankingItems = currentRegion ? getRankingItems(currentRegion.id) : null;
    const offerIds = rankingItems ? rankingItems.map((item) => item.offerId) : [];
    const {data: rankingOffers} = useGetOfferDetailListQuery({offerIds});

    const sortedRankingItems = rankingItems ? sortBy(rankingItems, "regionOrder") : null;

    const podiumItems = sortedRankingItems ? getPodiumItems(sortedRankingItems, Boolean(userDevice.isMobile)) : null;

    const hasAfterPodiumItems = sortedRankingItems ? sortedRankingItems.length > 3 : null;
    const afterPodiumItems = sortedRankingItems ? sortedRankingItems.splice(3, sortedRankingItems.length - 1) : null;

    return (
        <div>
            {currentRegion && rankingOffers && (
                <div css={offerLists}>
                    {podiumItems && (
                        <ul css={podiumList}>
                            {podiumItems.map((item) => {
                                const podiumOffer = rankingOffers.find((offer) => offer.id === item.offerId);

                                if (!podiumOffer) {
                                    return null;
                                }

                                return (
                                    <OfferRankingCard
                                        key={`rolip_${item.offerId}`}
                                        place={item.regionOrder}
                                        score={item.rating}
                                        ratingDescription={item.ratingDescription}
                                        offer={podiumOffer}
                                    />
                                );
                            })}
                        </ul>
                    )}
                    {hasAfterPodiumItems && afterPodiumItems && (
                        <ul css={afterPodiumList}>
                            {afterPodiumItems.map((item) => {
                                const afterPodiumOffer = rankingOffers.find((offer) => offer.id === item.offerId);

                                if (!afterPodiumOffer) {
                                    return null;
                                }

                                return <OfferRankingListItem key={`roliap_${item.offerId}`} score={item.rating} offer={afterPodiumOffer} />;
                            })}
                        </ul>
                    )}
                </div>
            )}
        </div>
    );
}

// Utils
function getPodiumItems(sortedItems: IRankingItem[], isMobile: boolean) {
    if (isMobile) {
        return sortedItems.slice(0, 3);
    }

    return [sortedItems[1], sortedItems[0], sortedItems[2]];
}

// Styles
const offerLists = css`
    display: flex;
    flex-direction: column;
    gap: ${crs(3.5)};
    ${onDesktop(css`
        gap: ${crs(8.5)};
    `)}
`;

const podiumList = css`
    ${listUnStyled};
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: ${crs(3)};
    align-items: center;
    justify-content: center;

    @media screen and (min-width: ${rankingBigViewBreakpoint}) {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: ${crs(5)} 1fr minmax(${crs(5)}, max-content);
    }
`;

const afterPodiumList = css`
    ${listUnStyled};
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: ${crs(3)};
    align-items: center;
    justify-content: center;
`;
import {useParams} from "react-router";
import {css} from "@emotion/react";

import {calculateRemSize as crs, listUnStyled, onDesktop} from "@pg-design/helpers-css";
import {sortBy} from "@pg-mono/nodash";
import {useUserDevice} from "@pg-mono/user-device";

import {useGetOfferDetailListQuery} from "../../../../offer/api/get_offer_detail_list";
import {useGetRegionDetailListBySlugQuery} from "../../../../region/api/get_region_detail_list_by_slug";
import {rankingBigViewBreakpoint} from "../../../constants/ranking_big_view_breakpoint";
import {IRankingItem} from "../../../types/IRankingItem";
import {IRankingListingViewParams} from "../../../types/IRankingListingViewParams";
import {getRankingItems} from "../../../utils/get_ranking_items";
import {OfferRankingCard} from "./OfferRankingCard";
import {OfferRankingListItem} from "./OfferRankingListItem";

export function OfferRankingList() {
    const userDevice = useUserDevice();
    const {citySlug} = useParams<IRankingListingViewParams>();
    const {data} = useGetRegionDetailListBySlugQuery({slug: citySlug});
    const currentRegion = data?.results[0];
    const rankingItems = currentRegion ? getRankingItems(currentRegion.id) : null;
    const offerIds = rankingItems ? rankingItems.map((item) => item.offerId) : [];
    const {data: rankingOffers} = useGetOfferDetailListQuery({offerIds});

    const sortedRankingItems = rankingItems ? sortBy(rankingItems, "regionOrder") : null;

    const podiumItems = sortedRankingItems ? getPodiumItems(sortedRankingItems, Boolean(userDevice.isMobile)) : null;

    const hasAfterPodiumItems = sortedRankingItems ? sortedRankingItems.length > 3 : null;
    const afterPodiumItems = sortedRankingItems ? sortedRankingItems.splice(3, sortedRankingItems.length - 1) : null;

    return (
        <div>
            {currentRegion && rankingOffers && (
                <div css={offerLists}>
                    {podiumItems && (
                        <ul css={podiumList}>
                            {podiumItems.map((item) => {
                                const podiumOffer = rankingOffers.find((offer) => offer.id === item.offerId);

                                if (!podiumOffer) {
                                    return null;
                                }

                                return (
                                    <OfferRankingCard
                                        key={`rolip_${item.offerId}`}
                                        place={item.regionOrder}
                                        score={item.rating}
                                        ratingDescription={item.ratingDescription}
                                        offer={podiumOffer}
                                    />
                                );
                            })}
                        </ul>
                    )}
                    {hasAfterPodiumItems && afterPodiumItems && (
                        <ul css={afterPodiumList}>
                            {afterPodiumItems.map((item) => {
                                const afterPodiumOffer = rankingOffers.find((offer) => offer.id === item.offerId);

                                if (!afterPodiumOffer) {
                                    return null;
                                }

                                return <OfferRankingListItem key={`roliap_${item.offerId}`} score={item.rating} offer={afterPodiumOffer} />;
                            })}
                        </ul>
                    )}
                </div>
            )}
        </div>
    );
}

// Utils
function getPodiumItems(sortedItems: IRankingItem[], isMobile: boolean) {
    if (isMobile) {
        return sortedItems.slice(0, 3);
    }

    return [sortedItems[1], sortedItems[0], sortedItems[2]];
}

// Styles
const offerLists = css`
    display: flex;
    flex-direction: column;
    gap: ${crs(3.5)};
    ${onDesktop(css`
        gap: ${crs(8.5)};
    `)}
`;

const podiumList = css`
    ${listUnStyled};
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: ${crs(3)};
    align-items: center;
    justify-content: center;

    @media screen and (min-width: ${rankingBigViewBreakpoint}) {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: ${crs(5)} 1fr minmax(${crs(5)}, max-content);
    }
`;

const afterPodiumList = css`
    ${listUnStyled};
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: ${crs(3)};
    align-items: center;
    justify-content: center;
`;
